import React from 'react'
import UiMainWrapper from "../../components/common/UiMainWrapper"
import TopHeader from "../../components/header/TopHeader"
import ShopInnerBanner from "./Views/ShopProductBanner"
import { UiBannerBottomBar } from '../../components/common/UiBannerBottomBar';
import {
    UiContentWr,
    UiContentCol,

} from "../../components/common/UiPageElements"
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import MembershipsList from "./Views/MembershipsList"
import ShopFilter from "./Views/ShopFilter"
import Footer from "../../components/footer/Footer"

export default function MembershipWrapper(props) {

    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <ShopInnerBanner title="Memberships"
                    description="Your already working hard, enjoy the benefits of various rewards you, your team and your family can enjoy." />
                <UiBannerBottomBar
                    prevPage="Shop"
                    prevPageLink="/ui"
                    currentPage="Broswe All Products"
                    currentPageLink="/ui/incentives-pre-register" />

                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="4" xl="3">
                            <UiContentCol>
                                <ShopFilter />
                            </UiContentCol>
                        </UiCol>
                        <UiCol lg="8" xl="9" className="mt-4">
                            <MembershipsList />
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <Footer />
            </UiMainWrapper>

        </>
    )
}
